import { BANNERS_SERVICE } from "@/services/banners.service.js";

const state = {
    bannerOutput: null,
    processTask: false
};

const actions = {
    getActiveBanner({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('bannerRequest');

        BANNERS_SERVICE.getActiveBanners()
            .then(
                response => {
                    commit('bannerSuccess', response);
                },
                error => {
                    commit('bannerFailure', error);
                }
            );
    }
};

const mutations = {
    bannerRequest(state) {
        state.processTask = null;
    },
    bannerSuccess(state, response) {
        if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
            state.bannerOutput = response.data[0];
        } else {
            state.bannerOutput = null;
        }
        state.processTask = true;
    },
    bannerFailure(state) {
        state.bannerOutput = null;
        state.processTask = false;
    }
};

export const banners = {
    namespaced: true,
    state,
    actions,
    mutations
};
